// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*************** 
Line animation 
***************/

@keyframes sampleMoving {
  0% {
    stroke-dashoffset: var(--dashOffsetValueReversed);
  }

  100% {
    stroke-dashoffset: var(--dashOffsetValue);
  }
}

svg #cems_graphics #lines-active {
  --dashArrayValue: 50;
  --dashOffsetValue: -50;
  --dashOffsetValueReversed: 50;
  --animationSpeed: 1s;
  --lineColor: white;
}

svg.default #cems_graphics #lines-active {
  --lineColor: var(--os-graphical-device-pipe-default);
}

svg.air #cems_graphics #lines-active {
  --lineColor: blue;
}

svg.span1 #cems_graphics #lines-active,
svg.gas #cems_graphics #lines-active {
  --lineColor: red;
}

svg.span2 #cems_graphics #lines-active {
  --lineColor: red;
}

/****************************
CEMS (ENVEA and THERMO)
***************************/
svg #cems_graphics #line-probe-to-gasAnalyzer-active,
svg #cems_graphics #line-valveJunction-to-probe-active,
svg #cems_graphics #line-scuAir-to-valveJunction-active,
svg #cems_graphics #line-scuSpan1-to-valveJunction-active,
svg #cems_graphics #line-scuSpan2-to-valveJunction-active,
svg #cems_graphics #line-valveJunction-to-gasAnalyzer-active,
svg #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active,
svg #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active,
svg #cems_graphics #line-bypass-active {
  stroke: none;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  animation-play-state: paused;
}

/* REVERSE LINE ANIMATION FLOW IN FOLLOWING LINES IN HORIZONTAL VIEW CEMS */
svg #cems_graphics #horizontal_graphic #line-probe-to-gasAnalyzer-active,
svg #cems_graphics #horizontal_graphic #line-valveJunction-to-gasAnalyzer-active,
svg #cems_graphics #horizontal_graphic #line-gasAnalyzer-to-leftScrubber-out-active,
svg #cems_graphics #horizontal_graphic #line-gasAnalyzer-to-rightScrubber-out-active,
svg #cems_graphics #horizontal_graphic #line-bypass-active,
/* REVERSE LINE ANIMATION FLOW IN FOLLOWING LINES IN VERTICAL VIEW CEMS */
svg #cems_graphics #vertical_graphic #line-valveJunction-to-gasAnalyzer-active,
svg #cems_graphics #vertical_graphic #line-gasAnalyzer-to-leftScrubber-out-active,
svg #cems_graphics #vertical_graphic #line-gasAnalyzer-to-rightScrubber-out-active {
  animation-direction: reverse;
}

/* PROBE LINE TO GASANALYZER */
svg.default #cems_graphics #line-probe-to-gasAnalyzer-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

/**** SCU LINES TO VALVEJUNCTION TO GASANALYZER *****/
svg.air #cems_graphics #line-scuAir-to-valveJunction-active,
svg.air #cems_graphics #line-valveJunction-to-gasAnalyzer-active,
svg.span1 #cems_graphics #line-scuSpan1-to-valveJunction-active,
svg.span1 #cems_graphics #line-valveJunction-to-gasAnalyzer-active,
svg.span2 #cems_graphics #line-scuSpan2-to-valveJunction-active,
svg.span2 #cems_graphics #line-valveJunction-to-gasAnalyzer-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

/* Pause probe to gasAnalyzer line when air, span1 or span2 or gas valve is open */
svg.air #cems_graphics #line-probe-to-gasAnalyzer-active,
svg.span1 #cems_graphics #line-probe-to-gasAnalyzer-active,
svg.span2 #cems_graphics #line-probe-to-gasAnalyzer-active {
  stroke: transparent;
  animation-play-state: paused;
}

/***** LEFT (SCRUBBER) *****/
/* so2scubber uses left scrubber */
svg.left #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

/***** RIGHT (SCRUBBER) *****/
/* so2scubber uses right scrubber  */
svg.right #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

/**** BYPASS (SCRUBBER) *****/
/* bybass = gas skips so2Scrubber entirely and goest straight to converter */
svg.bypass #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active,
svg.bypass #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active {
  stroke: white;
  animation-play-state: paused;
}

svg.bypass #cems_graphics #line-bypass-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

/* 
systemprobe = gas moves from SCU to PROBE now and continues normal route from there
*/

svg.systemprobe.air #cems_graphics #line-probe-to-gasAnalyzer-active {
  stroke: var(--lineColor);
  animation-play-state: running;
  transform: translateZ(200px);
}

svg.systemprobe.span1 #cems_graphics #line-probe-to-gasAnalyzer-active {
  stroke: var(--lineColor);
  animation-play-state: running;
  transform: translateZ(100px);
}

svg.systemprobe.span2 #cems_graphics #line-probe-to-gasAnalyzer-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.systemprobe #cems_graphics #line-valveJunction-to-probe-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.systemprobe.air #cems_graphics #line-valveJunction-to-gasAnalyzer-active,
svg.systemprobe.span1 #cems_graphics #line-valveJunction-to-gasAnalyzer-active,
svg.systemprobe.span2 #cems_graphics #line-valveJunction-to-gasAnalyzer-active {
  stroke: white;
  animation-play-state: paused;
}

/* !! These are for the case when user has pressed activated systemprobe but has not opened air/span1/span2 so we would still be in default state */
svg.systemprobe.default #cems_graphics #line-probe-to-gasAnalyzer-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.systemprobe.default.right #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.systemprobe.default.left #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.systemprobe.default.bypass #cems_graphics #line-bypass-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.systemprobe.default #cems_graphics #line-valveJunction-to-probe-active {
  stroke: white;
  animation-play-state: paused;
}

/* DISABLED STATE! 
Use these when edge unit is on automatic control mode.
Meaning, disabled is active when serviceModeStatus === "AutoActive".
*/

/* Disable button color and  valve-icon inner color */
svg.disabled #cems_graphics [id^="button-"] rect,
svg.disabled #cems_graphics [id^="button-"] path {
  fill: var(--os-graphical-device-button-inactive-bg) !important;
}

/* Disable text from buttons */
svg.disabled #cems_graphics [id^="button-"] tspan {
  fill: var(--os-graphical-device-button-inactive-text);
}

/* Disable valve-icon outlines */
svg.disabled #cems_graphics [id^="button-"] path {
  stroke: var(--os-graphical-device-outline-dark);
}

/* 
ALERT STYLING 
*/

/* WATER LEVEL ALERT */
svg #cems_graphics #scrubber-waterContainer.water-level-alert #scrubber-water-level {
  fill: var(--os-surface-panel);
}

svg #cems_graphics #scrubber-waterContainer.water-level-alert tspan {
  fill: var(--os-status-error);
}

svg #cems_graphics #scrubber-waterContainer.water-level-alert #droplet path {
  animation: water-alarm-animation 5s linear infinite alternate;
}

@keyframes water-alarm-animation {
  84% {
    fill: white;
  }

  92% {
    fill: var(--os-status-error);
    /*rgba(255, 255, 255, 0);*/
  }

  100% {
    fill: white;
  }
}

/*************
ATEX-CEMS 
*************/

svg #cems_graphics #line-probe-to-gasAnalyzer-to-out-active,
svg #cems_graphics #line-calibrate-span-to-probe-active,
svg #cems_graphics #line-calibrate-air-to-probe-active,
svg #cems_graphics #line-air-to-gasAnalyzer-to-out-active,
svg #cems_graphics #line-span-to-gasAnalyzer-to-out-active {
  stroke: none;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  animation-play-state: paused;
}

svg.default #cems_graphics #line-probe-to-gasAnalyzer-to-out-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.air #cems_graphics #line-air-to-gasAnalyzer-to-out-active,
svg.gas #cems_graphics #line-span-to-gasAnalyzer-to-out-active,
svg.air.atex-to-probe #cems_graphics #line-calibrate-air-to-probe-active,
svg.gas.atex-to-probe #cems_graphics #line-calibrate-span-to-probe-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.air #cems_graphics #line-probe-to-gasAnalyzer-to-out-active,
svg.gas #cems_graphics #line-probe-to-gasAnalyzer-to-out-active {
  stroke: transparent;
  animation-play-state: paused;
}

svg.air.atex-to-probe #cems_graphics #line-air-to-gasAnalyzer-to-out-active,
svg.gas.atex-to-probe #cems_graphics #line-span-to-gasAnalyzer-to-out-active {
  stroke: transparent;
  animation-play-state: paused;
}

svg.air.atex-to-probe #cems_graphics #line-probe-to-gasAnalyzer-to-out-active,
svg.gas.atex-to-probe #cems_graphics #line-probe-to-gasAnalyzer-to-out-active {
  stroke: var(--lineColor);
  animation-play-state: running;
}

svg.air #cems_graphics #icon-valve-mca10 path,
svg.gas #cems_graphics #icon-valve-mca10 path {
  fill: var(--os-surface-panel-transparent);
  stroke: var(--os-graphical-device-outline-light);
}

svg.air #cems_graphics #icon-valve-toProbe path,
svg.gas #cems_graphics #icon-valve-toProbe path {
  fill: var(--os-graphical-device-outline-dark);
  stroke: var(--os-graphical-device-outline-light);
}

svg.air.atex-to-probe #cems_graphics #icon-valve-mca10 path,
svg.gas.atex-to-probe #cems_graphics #icon-valve-mca10 path {
  fill: var(--os-graphical-device-outline-dark);
  stroke: var(--os-graphical-device-outline-light);
}

svg.air.atex-to-probe #cems_graphics #icon-valve-toProbe path,
svg.gas.atex-to-probe #cems_graphics #icon-valve-toProbe path {
  fill: var(--os-surface-panel-transparent);
  stroke: var(--os-graphical-device-outline-light);
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/components/graphicalView/2D/cems_styles.css"],"names":[],"mappings":"AAAA;;eAEe;;AAEf;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;;;;;;;;;EASE,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,gEAAgE;EAChE,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E;;;;;;;;;EASE,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;;;;;;EAME,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,kFAAkF;AAClF;;;EAGE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B,kCAAkC;AAClC;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B,oCAAoC;AACpC;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B,4EAA4E;AAC5E;;EAEE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;CAEC;;AAED;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;AAC9B;;AAEA,mJAAmJ;AACnJ;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;;;CAGC;;AAED,qDAAqD;AACrD;;EAEE,8DAA8D;AAChE;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;AACvD;;AAEA,gCAAgC;AAChC;EACE,+CAA+C;AACjD;;AAEA;;CAEC;;AAED,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;aAEa;;AAEb;;;;;EAKE,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,gEAAgE;EAChE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;;EAIE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;EAEE,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;;EAEE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;;EAEE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;;EAEE,yCAAyC;EACzC,gDAAgD;AAClD","sourcesContent":["/*************** \nLine animation \n***************/\n\n@keyframes sampleMoving {\n  0% {\n    stroke-dashoffset: var(--dashOffsetValueReversed);\n  }\n\n  100% {\n    stroke-dashoffset: var(--dashOffsetValue);\n  }\n}\n\nsvg #cems_graphics #lines-active {\n  --dashArrayValue: 50;\n  --dashOffsetValue: -50;\n  --dashOffsetValueReversed: 50;\n  --animationSpeed: 1s;\n  --lineColor: white;\n}\n\nsvg.default #cems_graphics #lines-active {\n  --lineColor: var(--os-graphical-device-pipe-default);\n}\n\nsvg.air #cems_graphics #lines-active {\n  --lineColor: blue;\n}\n\nsvg.span1 #cems_graphics #lines-active,\nsvg.gas #cems_graphics #lines-active {\n  --lineColor: red;\n}\n\nsvg.span2 #cems_graphics #lines-active {\n  --lineColor: red;\n}\n\n/****************************\nCEMS (ENVEA and THERMO)\n***************************/\nsvg #cems_graphics #line-probe-to-gasAnalyzer-active,\nsvg #cems_graphics #line-valveJunction-to-probe-active,\nsvg #cems_graphics #line-scuAir-to-valveJunction-active,\nsvg #cems_graphics #line-scuSpan1-to-valveJunction-active,\nsvg #cems_graphics #line-scuSpan2-to-valveJunction-active,\nsvg #cems_graphics #line-valveJunction-to-gasAnalyzer-active,\nsvg #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active,\nsvg #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active,\nsvg #cems_graphics #line-bypass-active {\n  stroke: none;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  animation-play-state: paused;\n}\n\n/* REVERSE LINE ANIMATION FLOW IN FOLLOWING LINES IN HORIZONTAL VIEW CEMS */\nsvg #cems_graphics #horizontal_graphic #line-probe-to-gasAnalyzer-active,\nsvg #cems_graphics #horizontal_graphic #line-valveJunction-to-gasAnalyzer-active,\nsvg #cems_graphics #horizontal_graphic #line-gasAnalyzer-to-leftScrubber-out-active,\nsvg #cems_graphics #horizontal_graphic #line-gasAnalyzer-to-rightScrubber-out-active,\nsvg #cems_graphics #horizontal_graphic #line-bypass-active,\n/* REVERSE LINE ANIMATION FLOW IN FOLLOWING LINES IN VERTICAL VIEW CEMS */\nsvg #cems_graphics #vertical_graphic #line-valveJunction-to-gasAnalyzer-active,\nsvg #cems_graphics #vertical_graphic #line-gasAnalyzer-to-leftScrubber-out-active,\nsvg #cems_graphics #vertical_graphic #line-gasAnalyzer-to-rightScrubber-out-active {\n  animation-direction: reverse;\n}\n\n/* PROBE LINE TO GASANALYZER */\nsvg.default #cems_graphics #line-probe-to-gasAnalyzer-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\n/**** SCU LINES TO VALVEJUNCTION TO GASANALYZER *****/\nsvg.air #cems_graphics #line-scuAir-to-valveJunction-active,\nsvg.air #cems_graphics #line-valveJunction-to-gasAnalyzer-active,\nsvg.span1 #cems_graphics #line-scuSpan1-to-valveJunction-active,\nsvg.span1 #cems_graphics #line-valveJunction-to-gasAnalyzer-active,\nsvg.span2 #cems_graphics #line-scuSpan2-to-valveJunction-active,\nsvg.span2 #cems_graphics #line-valveJunction-to-gasAnalyzer-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\n/* Pause probe to gasAnalyzer line when air, span1 or span2 or gas valve is open */\nsvg.air #cems_graphics #line-probe-to-gasAnalyzer-active,\nsvg.span1 #cems_graphics #line-probe-to-gasAnalyzer-active,\nsvg.span2 #cems_graphics #line-probe-to-gasAnalyzer-active {\n  stroke: transparent;\n  animation-play-state: paused;\n}\n\n/***** LEFT (SCRUBBER) *****/\n/* so2scubber uses left scrubber */\nsvg.left #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\n/***** RIGHT (SCRUBBER) *****/\n/* so2scubber uses right scrubber  */\nsvg.right #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\n/**** BYPASS (SCRUBBER) *****/\n/* bybass = gas skips so2Scrubber entirely and goest straight to converter */\nsvg.bypass #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active,\nsvg.bypass #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active {\n  stroke: white;\n  animation-play-state: paused;\n}\n\nsvg.bypass #cems_graphics #line-bypass-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\n/* \nsystemprobe = gas moves from SCU to PROBE now and continues normal route from there\n*/\n\nsvg.systemprobe.air #cems_graphics #line-probe-to-gasAnalyzer-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n  transform: translateZ(200px);\n}\n\nsvg.systemprobe.span1 #cems_graphics #line-probe-to-gasAnalyzer-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n  transform: translateZ(100px);\n}\n\nsvg.systemprobe.span2 #cems_graphics #line-probe-to-gasAnalyzer-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.systemprobe #cems_graphics #line-valveJunction-to-probe-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.systemprobe.air #cems_graphics #line-valveJunction-to-gasAnalyzer-active,\nsvg.systemprobe.span1 #cems_graphics #line-valveJunction-to-gasAnalyzer-active,\nsvg.systemprobe.span2 #cems_graphics #line-valveJunction-to-gasAnalyzer-active {\n  stroke: white;\n  animation-play-state: paused;\n}\n\n/* !! These are for the case when user has pressed activated systemprobe but has not opened air/span1/span2 so we would still be in default state */\nsvg.systemprobe.default #cems_graphics #line-probe-to-gasAnalyzer-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.systemprobe.default.right #cems_graphics #line-gasAnalyzer-to-rightScrubber-out-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.systemprobe.default.left #cems_graphics #line-gasAnalyzer-to-leftScrubber-out-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.systemprobe.default.bypass #cems_graphics #line-bypass-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.systemprobe.default #cems_graphics #line-valveJunction-to-probe-active {\n  stroke: white;\n  animation-play-state: paused;\n}\n\n/* DISABLED STATE! \nUse these when edge unit is on automatic control mode.\nMeaning, disabled is active when serviceModeStatus === \"AutoActive\".\n*/\n\n/* Disable button color and  valve-icon inner color */\nsvg.disabled #cems_graphics [id^=\"button-\"] rect,\nsvg.disabled #cems_graphics [id^=\"button-\"] path {\n  fill: var(--os-graphical-device-button-inactive-bg) !important;\n}\n\n/* Disable text from buttons */\nsvg.disabled #cems_graphics [id^=\"button-\"] tspan {\n  fill: var(--os-graphical-device-button-inactive-text);\n}\n\n/* Disable valve-icon outlines */\nsvg.disabled #cems_graphics [id^=\"button-\"] path {\n  stroke: var(--os-graphical-device-outline-dark);\n}\n\n/* \nALERT STYLING \n*/\n\n/* WATER LEVEL ALERT */\nsvg #cems_graphics #scrubber-waterContainer.water-level-alert #scrubber-water-level {\n  fill: var(--os-surface-panel);\n}\n\nsvg #cems_graphics #scrubber-waterContainer.water-level-alert tspan {\n  fill: var(--os-status-error);\n}\n\nsvg #cems_graphics #scrubber-waterContainer.water-level-alert #droplet path {\n  animation: water-alarm-animation 5s linear infinite alternate;\n}\n\n@keyframes water-alarm-animation {\n  84% {\n    fill: white;\n  }\n\n  92% {\n    fill: var(--os-status-error);\n    /*rgba(255, 255, 255, 0);*/\n  }\n\n  100% {\n    fill: white;\n  }\n}\n\n/*************\nATEX-CEMS \n*************/\n\nsvg #cems_graphics #line-probe-to-gasAnalyzer-to-out-active,\nsvg #cems_graphics #line-calibrate-span-to-probe-active,\nsvg #cems_graphics #line-calibrate-air-to-probe-active,\nsvg #cems_graphics #line-air-to-gasAnalyzer-to-out-active,\nsvg #cems_graphics #line-span-to-gasAnalyzer-to-out-active {\n  stroke: none;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  animation-play-state: paused;\n}\n\nsvg.default #cems_graphics #line-probe-to-gasAnalyzer-to-out-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.air #cems_graphics #line-air-to-gasAnalyzer-to-out-active,\nsvg.gas #cems_graphics #line-span-to-gasAnalyzer-to-out-active,\nsvg.air.atex-to-probe #cems_graphics #line-calibrate-air-to-probe-active,\nsvg.gas.atex-to-probe #cems_graphics #line-calibrate-span-to-probe-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.air #cems_graphics #line-probe-to-gasAnalyzer-to-out-active,\nsvg.gas #cems_graphics #line-probe-to-gasAnalyzer-to-out-active {\n  stroke: transparent;\n  animation-play-state: paused;\n}\n\nsvg.air.atex-to-probe #cems_graphics #line-air-to-gasAnalyzer-to-out-active,\nsvg.gas.atex-to-probe #cems_graphics #line-span-to-gasAnalyzer-to-out-active {\n  stroke: transparent;\n  animation-play-state: paused;\n}\n\nsvg.air.atex-to-probe #cems_graphics #line-probe-to-gasAnalyzer-to-out-active,\nsvg.gas.atex-to-probe #cems_graphics #line-probe-to-gasAnalyzer-to-out-active {\n  stroke: var(--lineColor);\n  animation-play-state: running;\n}\n\nsvg.air #cems_graphics #icon-valve-mca10 path,\nsvg.gas #cems_graphics #icon-valve-mca10 path {\n  fill: var(--os-surface-panel-transparent);\n  stroke: var(--os-graphical-device-outline-light);\n}\n\nsvg.air #cems_graphics #icon-valve-toProbe path,\nsvg.gas #cems_graphics #icon-valve-toProbe path {\n  fill: var(--os-graphical-device-outline-dark);\n  stroke: var(--os-graphical-device-outline-light);\n}\n\nsvg.air.atex-to-probe #cems_graphics #icon-valve-mca10 path,\nsvg.gas.atex-to-probe #cems_graphics #icon-valve-mca10 path {\n  fill: var(--os-graphical-device-outline-dark);\n  stroke: var(--os-graphical-device-outline-light);\n}\n\nsvg.air.atex-to-probe #cems_graphics #icon-valve-toProbe path,\nsvg.gas.atex-to-probe #cems_graphics #icon-valve-toProbe path {\n  fill: var(--os-surface-panel-transparent);\n  stroke: var(--os-graphical-device-outline-light);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
